
import { getGetters } from '@/store/getters'
import { getMutations } from '@/store/mutations'
import { getActions } from '@/store/actions'
import { Initial as model } from '@/models/api_v1'
import { LLMService as service } from '@/services/api_v1/llm'
import { useStore } from 'vuex'


// Init
const getInitialState = () => ({
  isInit: null,
  items: null,
  itemsMap: {},
  itemInit: model.initialState(),
});

// Import
const getters = getGetters()
const mutations = getMutations({ model })
const actions = {
  ...getActions({ model, service, init: getInitialState() }),

  async fetchThread({ state, commit, dispatch }, barcode) {
    let output = null
    try {
      output = await service.fetchThread(barcode)
        .then((response) => {
          return response
        })
    } catch (error) {
      console.error('LLM.fetchThread', error)
      throw error
    }
    return output
  },
  async createMessage({ state, commit, dispatch }, {
    message,
    barcode
  }) {
    let output = null
    try {
      output = await service.createMessage(message, barcode)
        .then((response) => {
          return response
        })
    } catch (error) {
      console.error('LLM.createMessage', error)
      throw error
    }
    return output
  },
  async createThread({ state, commit, dispatch }, {
    test_type,
    barcode,
    patient_name,
    patient_gender
  }) {
    let output = null
    try {
      output = await service.createThread({
        test_type,
        barcode,
        patient_name,
        patient_gender
      }).then((response) => {
        return response
      })
    } catch (error) {
      console.error('LLM.createThread', error)
      throw error
    }
    return output
  },
}

// Export
export default {
  namespaced: true,
  state: getInitialState(),
  getters,
  mutations,
  actions
}